import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import InlandFiberLogo from './InlandFiberLogo';
import './Header.css';

const Header = () => {
  const { isAuthenticated, user, logout } = useAuth();

  const navLinkClass = ({ isActive }) =>
    isActive ? 'header-nav-link header-nav-link-active' : 'header-nav-link';

  return (
    <header className="header">
      <div className="header-container">
        <Link to="/" className="header-logo">
          <InlandFiberLogo className="header-logo-img" alt="Inland Fiber Services Logo" />
        </Link>

        <nav className="header-nav">
          <NavLink to="/" end className={navLinkClass}>Home</NavLink>
          <NavLink to="/pricing" className={navLinkClass}>Services</NavLink>
          <NavLink to="/colo-calculator" className={navLinkClass}>Colo by the U</NavLink>
          {isAuthenticated ? (
            <>
              <NavLink to="/dashboard" className={navLinkClass}>Dashboard</NavLink>
              {user?.isAdmin && (
                <NavLink to="/admin" className={navLinkClass}>Admin</NavLink>
              )}
              <button onClick={logout} className="header-nav-link header-nav-button">
                Logout
              </button>
            </>
          ) : (
            <>
              <NavLink to="/login" className={navLinkClass}>Login</NavLink>
              <Link to="/register" className="header-nav-link header-nav-cta">
                Get Started
              </Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
};

export default Header;

